// NodelistFilterValueInput.jsx

import React from 'react';

// Components
import CheckboxList from 'components/checkboxlist/CheckboxList';
import SelectInput from 'components/selectinput/SelectInput';
import useNodelistTargetOptions from 'node/form/fields/nodelist/useNodelistTargetOptions';

/**
 * NodelistFilterValueInput
 *
 * Picks one or more related records for a nodelist filter row.
 *
 * @returns {ReactNode}
 */
const NodelistFilterValueInput = ({
  fieldDef,
  multi = false,
  value,
  onChange,
}) => {
  const targetType = String(fieldDef?.targetType || '').trim();
  const { options, isLoading } = useNodelistTargetOptions({
    targetType,
    enabled: Boolean(targetType),
  });

  if (!targetType) {
    return <div className="view-modal-row-spacer" />;
  }

  if (multi) {
    const selectedValues = Array.isArray(value) ? value : [];
    return (
      <CheckboxList
        options={options.map((option) => ({
          value: option.value,
          label: option.label,
        }))}
        values={selectedValues}
        checkboxSize={18}
        multiSelect
        onChange={(nextValues) => onChange?.(nextValues)}
      />
    );
  }

  return (
    <SelectInput
      value={value || ''}
      options={[
        { value: '', label: '' },
        ...options,
      ]}
      placeholder={isLoading ? 'Loading...' : 'Select item...'}
      emptyText="No items available"
      onValueChange={(nextValue) => onChange?.(nextValue)}
      width="100%"
      popupZIndex={3000}
    />
  );
};

// Dev Tools
NodelistFilterValueInput.displayName = 'NodelistFilterValueInput';

export default NodelistFilterValueInput;
